import { when } from 'k-ramel'
import { routeNotDefined } from './helpers'
import {
  locale,
  router,
  exception,
  ready,
  authentification,
} from './reactions'

export default [
  // global exception
  when('@@krml/EXCEPTION')(exception.log),

  // ready
  when('@@krml/AUTHENTIFICATION/ENDED')(ready.init),

  // authentification
  when('@@krml/INIT')(authentification.init),

  // locales
  when('@@http/LOCALES>GET>ENDED')(locale.set),

  // global routing
  when(routeNotDefined)(router.goToHome),
  when('ROUTER_LOCATION_CHANGED')(router.setScreenName),

]
